<template>
  <el-main v-loading="loading">
    <el-dialog title="卷面详情" :visible.sync="paper_show" width="700px">
      <Paper :answer_table="answer_table"></Paper>
    </el-dialog>
    <el-form inline size="mini">
      <el-form-item label="科目">
        <el-select v-model="search_form.subject" ref="search_form_subject" placeholder="请选择"
                   @change="on_subject_change">
          <el-option
              v-for="subject in subject_choices"
              :label="subject"
              :key="subject"
              :value="subject">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        考试：
        <el-autocomplete
            v-model="search_form.exam_name"
            :fetch-suggestions="query_exam_name"
            placeholder="考试名称关键词查询"
            @select="on_exam_select"
            clearable
            style="width: 400px;"
        ></el-autocomplete>
      </el-form-item>
      <br>
      <el-form-item>
        学级：
        <el-date-picker v-model="search_form.year" type="year" format="yyyy" value-format="yyyy"
                        :editable="false"
                        style="width: 120px;" placeholder="学级"></el-date-picker>
      </el-form-item>
      <el-form-item>
        班级：
        <el-input v-model="search_form.class_num" placeholder="班号" style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item>
        姓名：
        <el-input v-model="search_form.name" placeholder="姓名" style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item>
        学号：
        <el-input v-model="search_form.id_num" placeholder="学号" style="width: 120px;"></el-input>
      </el-form-item>
      <el-form-item label="缺考">
        <el-select v-model="search_form.join_flag" ref="search_form_join_flag" placeholder="请选择" clearable>
          <el-option
              label="是"
              :value="false">
          </el-option>
          <el-option
              label="否"
              :value="true">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query_paper(true)">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-pagination
        background
        layout="prev, pager, next, sizes, total, jumper"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        :total="table_totle"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
    <el-table
        :data="table_data"
        border
        fit
        size="mini"
        style="width: 100%">
      <el-table-column
          prop="id_num"
          label="学号">
      </el-table-column>
      <el-table-column
          prop="name"
          label="姓名">
      </el-table-column>
      <el-table-column
          label="缺考">
        <template slot-scope="scope">
          <template v-if="scope.row.join_flag">否</template>
          <template v-else>是</template>
        </template>
      </el-table-column>
      <el-table-column
          prop="score"
          label="得分">
      </el-table-column>
      <el-table-column
          label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="show_paper(scope.row)" v-if="scope.row.join_flag">看卷</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
  // import XLSX from "xlsx";
  import global_ from "../global";
  import Paper from "../components/Paper";
  import Base from "./Base";

  const admin_api = global_.admin_api;
  // import FileSaver from "file-saver";

  export default {
    name: "PaperManage",
    extends: Base,
    created() {
    },
    components: {Paper},
    mounted() {
      this.$store.commit('set_current_url', "/paper_manage")
    },
    computed: {
      parent_group() {
        return this.$store.state.parent_group;
      },
    },
    methods: {
      error_hander(response) {
        let result_code = response.data['result_code']
        let result_info = response.data['result_info']
        if (result_code === '90') {
          this.$store.commit('set_login_state', false)
          this.$router.replace('/login')
        } else {
          this.$message({message: result_info, duration: 1000, type: 'error'})
        }
      },
      handleCurrentChange(v) {
        this.page_num = v
        this.query_paper()
      },
      handleSizeChange(v) {
        this.page_size = v
        this.query_paper()
      },
      show_paper(row) {
        let request_data = {
          service_name: 'show_paper',
          paper_id: row.id
        }
        this.axios.post(admin_api, request_data).then(response => {
          let result_code = response.data['result_code']
          let result_info = response.data['result_info']
          if (result_code === '00') {
            this.answer_table = result_info.answer_table
            this.paper_show = true
          } else {
            this.error_hander(response)
          }
        })
      },
      query_paper(is_new = false) {
        if (!this.search_form.exam_id || !this.search_form.exam_name) {
          this.$message({message: '请选择考试', duration: 1000, type: 'error'})
          return false
        }
        if (is_new) {
          this.page_num = 1
        }
        let request_data = {
          service_name: 'query_paper',
          page_num: this.page_num,
          page_size: this.page_size,
          search_form: this.search_form
        }
        this.axios.post(admin_api, request_data).then(response => {
          let result_code = response.data['result_code']
          let result_info = response.data['result_info']
          if (result_code === '00') {
            this.table_data = result_info['table_data']
            this.table_totle = result_info['table_totle']
          } else {
            this.error_hander(response)
          }
        })
      },
      on_exam_select(v) {
        this.search_form.exam_id = v.id
      },
      on_subject_change() {
        this.search_form.exam_id = ""
        this.search_form.exam_name = ""
      },
      query_exam_name(queryString, cb) {
        let results = []
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          let request_data = {
            service_name: 'query_exam_name',
            subject: this.search_form.subject,
            query_string: queryString
          }
          this.axios.post(admin_api, request_data).then(response => {
            let result_code = response.data['result_code']
            let result_info = response.data['result_info']
            if (result_code === '00') {
              cb(result_info);
            } else {
              cb(results);
            }
          })
        }, 300);
      }
    },
    data() {
      return {
        answer_table: [],
        timeout: null,
        paper_show: false,
        subject_choices: ['语文', '数学', '英语', '物理', '化学', '生物', '历史', '地理', '政治', '日语'],
        loading: false,
        search_form: {
          exam_id: "",
          exam_name: "",
          subject: "语文",
          year: "",
          name: "",
          class_num: "",
          join_flag: false,
        },
        select_student_show: false,
        page_num: 1,
        page_size: 10,
        table_totle: 0,
        table_data: [],
        exam_form_show: false,
        review_form_show: false,
        exam_form_edit_show: false,
        choice_table: [],
        choice_form_show: false,
        exam_form: {
          title: "",
          time_range: [],
          join_mode: 'p',
          describe: "",
          subject: "",
          group_student_flag: true
        },
        current_row: null,
      }
    }
  }
</script>

